import ContractsTaxiDriverUpdateRequest from "../../../../api/raily/contracts/taxi-driver/update/contracts-taxi-driver-update.request";
import ContractsTaxiDriverUpdateParams from "./contracts-taxi-driver-update-params";

const create = (
  params: ContractsTaxiDriverUpdateParams,
): ContractsTaxiDriverUpdateRequest => {
  return {
    contractId: params.contractUuid,
    disabled: !params.isActive,
    description: params.notes,
  };
};

const contractsTaxiDriverUpdateParamsFactory = {
  create,
};

export default contractsTaxiDriverUpdateParamsFactory;
